import { Request } from 'express'
import { getCookies } from 'lib/web/cookieUtils'

export const LAST_KNOWN_MEMBER_COOKIE = 'LK_M_ID'

// Returns the last known(logged in) member id
export function getLastKnownMemberId(req?: Request): string | undefined {
  if (IS_SSR && !req) return undefined
  const cookies = req ? req.cookies as Record<string, string> : getCookies()
  return cookies[LAST_KNOWN_MEMBER_COOKIE]
}
